import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getWeeklyReport } from "../../services/reports.service";

// Single async thunk to fetch both data and list
export const fetchWeeklyReport = createAsyncThunk(
  "weeklyReport/fetchWeeklyReport",
  async (_, { rejectWithValue }) => {
    try {
      const data = await getWeeklyReport();  // This gets both data and list from the API
      return {
        data: data.data,  // Weekly data
        list: data.list   // Leads data
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const weeklyReportSlice = createSlice({
  name: "weeklyReport",
  initialState: {
    data: [], // Holds the weekly report data
    list: [], // Holds the leads list data
    status: "idle", // idle | loading | succeeded | failed
    error: null, // Holds any error message
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWeeklyReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchWeeklyReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data; // Store weekly data
        state.list = action.payload.list; // Store leads list data
      })
      .addCase(fetchWeeklyReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;  // Store error message if the fetch fails
      });
  },
});

export default weeklyReportSlice.reducer;
